// Decides whether an investor has uploaded every document required to proceed
// past the document-verification step. Pure logic, mirroring the corrected
// isDocumentUploaded() rule in the document-verification component so the
// decision can be unit tested across every investor type.
//
// The US tax form is only collected from investors who are from the USA
// (the upload field is only rendered when isUserFromUsa === true), so its
// absence must never block a non-USA investor.
export const isInvestorDocumentsComplete = ({
	isCorporate,
	isProfessional,
	isUserFromUsa,
	hasAddressProof,
	hasNetWorth,
	hasPassportOrIdentifier,
	hasTaxForm,
	isAllCorporateFilesUploaded,
}) => {
	const shouldCollectUsTaxForm = !isCorporate && isUserFromUsa === true;
	const isTaxFormUploaded = !shouldCollectUsTaxForm || hasTaxForm;

	if (isProfessional) {
		return Boolean(
			hasAddressProof && hasNetWorth && hasPassportOrIdentifier && isTaxFormUploaded
		);
	}

	if (isCorporate) {
		return Boolean(isAllCorporateFilesUploaded);
	}

	return Boolean(hasAddressProof && hasPassportOrIdentifier && isTaxFormUploaded);
};
